export default __webpack_public_path__ + "static/media/matching-team-2.dba47a92.png";